__turbopack_context__.v({
  "body-container": "CxfslG_body-container",
  "container-cards": "CxfslG_container-cards",
  "container-cards-contacts": "CxfslG_container-cards-contacts",
  "link-return": "CxfslG_link-return",
  "link-return-arrow-left": "CxfslG_link-return-arrow-left",
  "link-return-cta": "CxfslG_link-return-cta",
  "main-body-container": "CxfslG_main-body-container",
  "main-image": "CxfslG_main-image",
  "press-topics": "CxfslG_press-topics",
  "section": "CxfslG_section",
  "siderail-container": "CxfslG_siderail-container",
});
